module.exports = function(cb) {
	require.ensure([], function(require) {
		cb(require("!!./DarkSky.js"));
	}, "DarkSky");
}